import type { FC } from 'react';
import { useEffect, useState } from 'react';
import type { ICompleteProfileForm } from '@/Module/Auth/Component';
import { AuthRegisterModal, ReferTypeModal } from '@/Module/Auth/Component';
import { authUpdatePersonAction } from '@/Module/Auth/Store/Action';
import { setSectionWelcome } from '@/Module/Auth/Store/Slice/AuthSlice';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const AuthConfirmFormModal: FC = () => {
  const dispatch = useAppDispatch();
  const person = useAppSelector(state => state.auth.person);
  const [isOpenRefer, setIsOpenRefer] = useState(false);
  const [needCompleteProfile, setNeedCompleteProfile] = useState(true);
  const section = useAppSelector(state => state.auth.section);
  const onCompleteProfileSuccess = (payLoad: ICompleteProfileForm) => {
    dispatch(authUpdatePersonAction({
      id: person!.id,
      fundametalId: person?.fundametalId,
      gender: person?.gender,
      name: payLoad.firstName,
      family: payLoad.lastName,
      gradeId: payLoad.grad.value,
      fieldId: payLoad.field?.value || null,
      birthDate: payLoad.birthDate!,
      stateId: payLoad.province?.value,
      cityId: payLoad.city?.value
    })).unwrap().then(() => {
      setNeedCompleteProfile(false);
      localStorage.setItem('step', '2');
      dispatch(setSectionWelcome(2));
      setIsOpenRefer(true);
    });
  };
  useEffect(() => {
    const step = Number(localStorage.getItem('step')) || 1;
    dispatch(setSectionWelcome(step));
    if (section === 510) setIsOpenRefer(false);
    if (section !== 510) setIsOpenRefer(true);
  }, [section]);
  return <div data-sentry-component="AuthConfirmFormModal" data-sentry-source-file="AuthConfirmFormModal.tsx">
      {section === 1 ? <AuthRegisterModal isOpen={needCompleteProfile} onSuccess={onCompleteProfileSuccess} /> : <ReferTypeModal isOpenRefer={isOpenRefer} />}
    </div>;
};
export default AuthConfirmFormModal;